export default __webpack_public_path__ + "assets/images/29f82c31cdf5a239e08b5a94fca6a52d.png";